import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    deleteRecord,
    deleteRecordSuccess,
    deleteRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    deleteFileRecord,
    deleteFileRecordSuccess,
    deleteFileRecordFailure,
    updateRecordStatus,
    changeStatus,
    fetchOpenSuccess,
    fetchOpenFailure,
    fetchOpen,
} from './agenda-task.action';

import {
    fetchRecordsSuccess as fetchRecordsSuccessClubs,
} from '../Clubs/clubs.action';

import {
    fetchRecordsSuccess as dossiersRecordSuccess,
} from '../Dossier/dossier.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { AgendaTaskTableService } from './agenda-task-table.service';
import { FileUploadService } from 'src/app/core/services/file-upload.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { DATA_LAYOUT_MODE } from '../layouts/layout';
import { HelperService } from 'src/app/core/services/helper.service';


@Injectable()
export class AgendaTaskRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'agenda-task?section='+this.moduleTableService.section+"&selected_club="+data.id+"&selected_dossier="+this.moduleTableService.dossierId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page)
                        
                        this.moduleTableService.clubs = data.clubs;
                        this.moduleTableService.categories = data.categories;
                        this.moduleTableService.statuses = data.statuses;

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: data.records, total: total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                const url = 'agenda-task/'+data.id+"/edit?club="+this.moduleTableService.clubId+"&dossier="+this.moduleTableService.dossierId;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.moduleTableService.dossierClub = data.dossierClub;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecordsSuccessClubs({ 
                                                    listData: response.data.clubs, 
                                                    total: 0, 
                                                    isVatValid: false 
                                                }));

                        this.store.dispatch(dossiersRecordSuccess({listData: data.dossiers, total: data.dossiers?.length}));
                        return fetchSingleRecordSuccess({dummyId: data.dummyId, singleData: data.task, files: data.files, statuses: data.statuses, categories: data.categories});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, "/agenda-task/section/progress");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchOpen$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchOpen),
            exhaustMap((data: any) => {
                const url = 'fetch-open-agendas/';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response: any) => {
                        
                        this.localStorageService.setItem("open-agenda-task", response);
                        const oldCount = this.moduleTableService.openTasks;
                        this.moduleTableService.openTasks = response;

                        if(oldCount !== response && (oldCount != undefined && response))
                            this.moduleTableService.loadRecords(); 

                        return fetchOpenSuccess();
                    }),
                    catchError((error) =>
                        of(error).pipe(
                            map(() => fetchOpenFailure({ error }))
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'agenda-task-update/'+data.id;
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        // if(data.isNew){
                            if(this.moduleTableService.clubId != 0){
                                this.routeService.triggerRoute(response, "/clubs/"+this.moduleTableService.clubId+"/agenda-tasks");
                            }
                            else if(this.moduleTableService.dossierId != 0){
                                this.routeService.triggerRoute(response, "/dossiers/detail/"+this.moduleTableService.dossierId, { activeTab: 'agenda-tasks' });
                            }
                            else{
                                this.routeService.triggerRoute(response, "/agenda-task/section/progress");
                            }
                        // }

                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    deleteData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteRecord),
            exhaustMap((data: any) => {
                const url = 'agenda-task/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(fetchRecords({id: this.moduleTableService.clubId}));
                        if(this.moduleTableService.clubId != 0){
                            this.routeService.triggerRoute(null, "/clubs/"+this.moduleTableService.clubId+"/agenda-tasks");
                        }
                        else if(this.moduleTableService.dossierId != 0){
                            this.routeService.triggerRoute(response, "/dossiers/detail/"+this.moduleTableService.dossierId, { activeTab: 'agenda-tasks' });
                        }
                        else{
                            this.routeService.triggerRoute(null, "/agenda-task/section/progress");
                        }
                        return deleteRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => deleteRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );
    
    deleteFileRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(deleteFileRecord),
            exhaustMap((data: any) => {
                
                const url = 'agenda-task/'+data.taskId+'/delete-file/'+data.id;
                return this.crudServerService.deleteData(url).pipe(
                    map( (response) => {
                        this.uploader.uploadQueue = this.uploader.uploadQueue.filter(f => f.isUploading && !f.isUploaded && !f.isCancelled);
                        this.store.dispatch(fetchSingleRecord({id: data.taskId}));
                        this.alertService.triggerAlert(response.message, "success");
                        // this.routeService.triggerRoute(null, "/agenda-task");
                        return deleteFileRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.uploader.uploadQueue = this.uploader.uploadQueue.filter(f => f.isUploading && !f.isUploaded && !f.isCancelled);
                                this.store.dispatch(fetchSingleRecord({id: data.taskId}));
                            }),
                            map(() => deleteFileRecordFailure({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );


    changeStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(changeStatus),
            exhaustMap((data: any) => {
                const url = 'contributie-agenda-task-status/'+data.id;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert("ALERTS.status-updated", "success");
                        this.moduleTableService.loadRecords();

                        return fetchSingleRecordSuccess({dummyId: data.dummyId, singleData: data.task, files: data.files, statuses: data.statuses, categories: data.categories});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                // this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private tableService: DatatableService,
        private moduleTableService: AgendaTaskTableService,
        private uploader: FileUploadService,
        private localStorageService: LocalStorageService,
        public helperService: HelperService
    ) { }

}